import Swiper from 'swiper';

const variantDetails = () => {
  class VariantDetails extends HTMLElement {
    constructor() {
      super();

      this.variantPicker = this.querySelector('variant-picker');
      this.galleryImages = this.querySelectorAll('.media-gallery [data-image-index]');
      this.productForm = this.querySelector('.product-form');
      this.selectedVariantId = this.querySelector('input[data-selected-variant-id]');
      this.productSkuElement = this.querySelector('[data-product-sku]');
  
      this.productMedia = new Swiper(document.querySelector('.pdpSwiper'), {
        freeMode: true,
        slidesPerView: 1,
        spaceBetween: 10
      });
    }
  
    connectedCallback() {
      if (this.variantPicker) {
        this.variantSelection();
      }
    }
  
    variantSelection(){
      this.galleryImages.forEach(galleryImage => {
        this.productForm.addEventListener('change', () => {
          this.variantImageMatching(galleryImage);
        });
      });
    }
  
    variantImageMatching(galleryImage) {
      if (galleryImage.getAttribute('data-variant-id') == this.selectedVariantId.getAttribute('value')) {
        galleryImage.classList.add('selected-variant-image');
  
        if (this.productSkuElement && galleryImage.getAttribute('data-variant-sku') != null) {
            const productSkuText = this.productSkuElement.dataset.text.replace('{{ sku }}', galleryImage.getAttribute('data-variant-sku'));
            this.productSkuElement.textContent = productSkuText;
        }
  
        if (window.matchMedia('(max-width: 767px)').matches) {
          this.productMedia.slideTo((galleryImage.getAttribute('data-image-index') - 1), 300, true);
          window.scrollTo({top: document.querySelector('.pdpSwiper').getBoundingClientRect().top + window.scrollY - 200, behavior: 'smooth'});
        }
      }
      if (galleryImage.getAttribute('data-variant-id') != this.selectedVariantId.getAttribute('value')) {
        galleryImage.classList.remove('selected-variant-image');
      }
    }
  }
  
  customElements.define('variant-details', VariantDetails);
}

export {
  variantDetails
}